import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import NoticeCircle from "@ingka/ssr-icon/paths/notice-circle";
import styles from "./ErrorContainer.module.css";
import { ErrorNotificationItem } from "./hooks/useErrorNotificationsState";

type ErrorContainerProps = {
  notifications: ErrorNotificationItem[];
  removeError: (notificationId: number) => void;
};

export const ErrorContainer = ({
  notifications,
  removeError,
}: ErrorContainerProps) => {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className={styles["root"]} data-testid="error-container">
      {notifications.map((notification) => (
        <FixaInlineMessage
          key={notification.id}
          body={notification.text}
          title={notification.title}
          variant={notification.variant ?? "negative"}
          dismissable
          onDismissClick={() => removeError(notification.id)}
          ssrIcon={NoticeCircle}
        />
      ))}
    </div>
  );
};
